export default "/_next/static/images/f6/thumb-f65a2e353d84192faac69dc4b80486ec.png";